<script setup lang="ts">
import type { Agent } from '@@/shared/agent/types';

defineProps<{
  agent: Agent
}>();

const emit = defineEmits<{
  close: []
}>();

const { t } = useI18n();
const { copy } = useClipboard();
const { notifySuccess } = useNotifications();
const open = defineModel<boolean>({ default: false });
const head = useLocaleHead();

const agentLink = computed(() => head.value.meta?.find((meta: Record<string, string>) => meta.property === `og:url`)?.content);

const seoMeta = computed(() => {
  if (!agentLink.value) return {
    whatsapp: ``,
    facebook: ``,
    linkedin: ``,
    mailTo: ``,
  };
  const whatsapp = new URL(`https://api.whatsapp.com/send/`);
  whatsapp.searchParams.append(`text`, agentLink.value);
  whatsapp.searchParams.append(`type`, `custom_url`);
  whatsapp.searchParams.append(`app_absent`, `0`);
  const facebook = new URL(`https://www.facebook.com/sharer/sharer.php`);
  facebook.searchParams.append(`u`, agentLink.value);
  const linkedin = new URL(`https://www.linkedin.com/shareArticle/`);
  linkedin.searchParams.append(`mini`, `true`);
  linkedin.searchParams.append(`url`, agentLink.value);
  const mailTo = new URL(`mailto:`);
  mailTo.searchParams.append(`body`, agentLink.value);
  return {
    whatsapp: whatsapp.href,
    facebook: facebook.href,
    linkedin: linkedin.href,
    mailTo: mailTo.href,
  };
});

function onCopy() {
  if (!agentLink.value) return;
  copy(agentLink.value);
  notifySuccess(t(`core.common.shared_social.copy_link.success`));
  emit(`close`);
}
</script>

<template>
  <IadDialog
    v-model="open"
    modal-name="valuation_share"
  >
    <template #top-content>
      <IadTitle
        :text="$t(`agent.shared_social.title`)"
        variant="large"
        tag="p"
      />
    </template>

    <div class="grid grid-cols-2 gap-m p-l w-screen max-w-lg">
      <IadBtn
        variant="outlined"
        target="_blank"
        :href="seoMeta.whatsapp"
        @click="emit(`close`)"
      >
        <Icon name="iad-icon:whatsapp" />
        Whatsapp
      </IadBtn>
      <IadBtn
        variant="outlined"
        target="_blank"
        :href="seoMeta.facebook"
        @click="emit(`close`)"
      >
        <Icon name="iad-icon:facebook" />
        Facebook
      </IadBtn>
      <IadBtn
        variant="outlined"
        target="_blank"
        :href="seoMeta.mailTo"
        @click="emit(`close`)"
      >
        <Icon name="iad-icon:mail" />
        Email
      </IadBtn>
      <IadBtn
        variant="outlined"
        target="_blank"
        :href="seoMeta.linkedin"
        @click="emit(`close`)"
      >
        <Icon name="iad-icon:linkedin" />
        linkedin
      </IadBtn>

      <IadBtn
        class="col-span-2"
        variant="outlined"
        target="_blank"
        @click="onCopy"
      >
        <Icon name="iad-icon:copy" />
        {{ $t(`core.common.shared_social.copy_link.title`) }}
      </IadBtn>
    </div>
  </IadDialog>
</template>
